import React from 'react';
import { Page, Document, Text, StyleSheet, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 10, fontSize: 7 },
  header: { marginBottom: 10 },
  row: { flexDirection: 'row', borderBottom: '1px solid #ccc' },
  colDesc: { width: '40%', padding: 4 },
  col: { width: '20%', textAlign: 'right', padding: 4 }
});

function formatarMoeda(valor) {
  const v = Math.abs(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  return valor < 0 ? `(${v})` : v;
}

const ExportDRE = ({data}) => {
    console.log('data.dados: ', data.dados)
    return (
        <Document>
            <Page size="A4" style={styles.page} orientation='landscape'>
                <Text style={styles.header}>
                    DRE - Demonstrativo de Resultado
                </Text>

                {/* Header */}
                <View style={styles.row}>
                    <Text style={styles.colDesc}>&nbsp;</Text>
                    {data.meses.map(m => (
                        <Text style={styles.col}>{m}</Text>
                    ))}
                </View>

                {/* Linhas */}
                {data.dados.map(linha => (
                    <View style={styles.row}>
                        <Text style={styles.colDesc}>{linha.nome}</Text>
                        {linha.valores.map(v => (
                            <Text style={styles.col}>
                                {formatarMoeda(v)}
                            </Text>
                        ))}
                    </View>
                ))}
            </Page>
        </Document>
    );
};

export default ExportDRE